import React from 'react';
import { Check, Download } from 'lucide-react';

const styles = {
  wrap: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderLeft: '5px solid #22c55e', // Thick green left accent
    borderRadius: '12px',
    padding: '24px 32px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    animation: 'fadeUp 0.4s ease both',
    position: 'relative',
    overflow: 'hidden',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.04)',
  },
  iconBox: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    background: '#f0fdf4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#22c55e',
    flexShrink: 0,
    zIndex: 2,
  },
  info: {
    flex: 1,
    minWidth: 0,
    zIndex: 2,
  },
  title: {
    fontSize: '19px',
    fontWeight: 700,
    color: '#166534', // Green title
    marginBottom: '4px',
    letterSpacing: '-0.01em',
  },
  sub: {
    fontSize: '14px',
    color: '#475569',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.5,
  },
  downloadBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '14px',
    fontWeight: 600,
    padding: '12px 24px',
    borderRadius: '10px',
    background: '#22c55e',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(34, 197, 94, 0.2)',
    zIndex: 2,
  },
};

export default function ResultBox({ conversion, file, onDownload }) {
  const getFileName = () => {
    if (!file) return null;
    if (file.name) return file.name;
    if (file.file && file.file.name) return file.file.name;
    return null;
  };

  const name = getFileName();
  const outName = name
    ? name.replace(/\.[^.]+$/, '') + conversion.toExt
    : 'output' + conversion.toExt;

  return (
    <div style={styles.wrap}>
      <div style={styles.iconBox}>
        <Check size={32} strokeWidth={3} />
        {/* Subtle decorative dots if needed, but keeping it clean for now */}
      </div>
      <div style={styles.info}>
        <div style={styles.title}>Conversion complete!</div>
        <div style={styles.sub}>
          <span style={{ color: '#1e293b', fontWeight: 600 }}>{outName}</span>
          <span style={{ color: '#475569', marginLeft: '6px' }}>is ready to download</span>
        </div>
      </div>
      <button style={styles.downloadBtn} onClick={onDownload}>
        <Download size={20} strokeWidth={2.5} />
        Download
      </button>
    </div>
  );
}
